import React from 'react'

import { DELIVERY_ISSUE_REPORTED_ICON } from '../../constants/urls'

interface DeliveryIssueReportedProps {
  show: boolean
}

const DeliveryIssueReported: React.FC<DeliveryIssueReportedProps> = ({
  show
}: DeliveryIssueReportedProps) => {
  if (!show) return null

  return (
    <div className="mx-3 mt-6 flex items-center justify-center gap-4 rounded-xl bg-[#FEFBE6] px-4 py-4">
      <img className="h-9 w-9" src={DELIVERY_ISSUE_REPORTED_ICON} alt="Reporte enviado" />
      <div>
        <p className="font-['Onest'] text-base font-semibold text-black">Reporte enviado</p>
        <p className="font-['Geist'] text-sm text-gray-500">Te contactaremos a la brevedad.</p>
      </div>
    </div>
  )
}

export default DeliveryIssueReported
